import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Facebook, Twitter, Linkedin } from 'lucide-react';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-navy text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Brand */}
                    <div>
                        <div className="flex items-center gap-2 mb-4">
                            <div className="w-10 h-10 bg-gold rounded-lg flex items-center justify-center">
                                <span className="text-navy font-bold text-xl">H</span>
                            </div>
                            <div>
                                <span className="font-heading text-xl font-bold">Hotel Motel</span>
                                <span className="font-heading text-xl font-bold text-gold ml-1">Club</span>
                            </div>
                        </div>
                        <p className="text-gray-400 text-sm mb-4">
                            The premier marketplace for hotel industry professionals. Buy, sell, and discover opportunities in hospitality.
                        </p>
                        <div className="flex gap-4">
                            <a href="#" className="text-gray-400 hover:text-gold transition-colors" aria-label="Facebook">
                                <Facebook className="w-5 h-5" />
                            </a>
                            <a href="#" className="text-gray-400 hover:text-gold transition-colors" aria-label="Twitter">
                                <Twitter className="w-5 h-5" />
                            </a>
                            <a href="#" className="text-gray-400 hover:text-gold transition-colors" aria-label="LinkedIn">
                                <Linkedin className="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="font-heading text-lg font-semibold mb-4">Quick Links</h3>
                        <ul className="space-y-2">
                            <li><Link to="/" className="footer-link">Home</Link></li>
                            <li><Link to="/listings" className="footer-link">Browse Listings</Link></li>
                            <li><Link to="/about" className="footer-link">About Us</Link></li>
                            <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
                            <li><Link to="/investor" className="footer-link">Investor Info</Link></li>
                        </ul>
                    </div>

                    {/* Categories */}
                    <div>
                        <h3 className="font-heading text-lg font-semibold mb-4">Categories</h3>
                        <ul className="space-y-2">
                            <li><Link to="/listings?category=hotel-furniture" className="footer-link">Hotel Furniture</Link></li>
                            <li><Link to="/listings?category=hotel-jobs" className="footer-link">Hotel Jobs</Link></li>
                            <li><Link to="/listings?category=housekeeping-supplies" className="footer-link">Housekeeping Supplies</Link></li>
                            <li><Link to="/listings?category=real-estate" className="footer-link">Real Estate</Link></li>
                            <li><Link to="/listings?category=events-announcements" className="footer-link">Events</Link></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="font-heading text-lg font-semibold mb-4">Contact Us</h3>
                        <ul className="space-y-3">
                            <li className="flex items-center gap-3 text-gray-400">
                                <Mail className="w-5 h-5 text-gold" />
                                <span>info@hotelmotelclub.com</span>
                            </li>
                            <li className="flex items-center gap-3 text-gray-400">
                                <Link to="/contact" className="text-gray-400 hover:text-white">
                                    Send us a message →
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-gray-400 text-sm">
                        © {currentYear} Hotel Motel Club. All rights reserved.
                    </p>
                    <div className="flex gap-6 items-center">
                        <Link to="/policies" className="text-gray-400 hover:text-white text-sm">Privacy Policy</Link>
                        <Link to="/policies" className="text-gray-400 hover:text-white text-sm">Terms of Service</Link>
                        <Link to="/faq" className="text-gray-400 hover:text-white text-sm">FAQ</Link>
                        <span className="text-gray-700">|</span>
                        <Link to="/admin" className="text-gray-500 hover:text-gold text-sm" data-testid="admin-login-link">
                            Admin Login
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
